import { ReactComponent as CeLogoIcon } from '@crazyegginc/hatch/dist/images/logo-crazy-egg-color.svg';
import { ProgressTracker } from './ProgressTracker';

export function Header({ currentStep, totalSteps, hasError }) {
  return (
    <header className="flex items-center justify-between px-4 py-5 sm:px-6 md:px-16 md:py-8">
      <div className="w-[118px] h-6 sm:h-[64px] pl-[22px] md:hidden" />
      <CeLogoIcon className="w-[114px] h-auto hidden md:block" />
      <ProgressTracker currentStep={currentStep} totalSteps={totalSteps} hasError={hasError} />
      <div className="w-[118px] h-6 sm:h-[64px] pr-[22px]" /> {/* Placeholder for spacing */}
    </header>
  );
}
